<template>
  <div class="data-list-container">
    <qp-side-view
      ref="qpSideview"
      :isSidebarActive="isSidebarActive"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
      @onQpUpdated="qpUpdated"
      @onQpInserted="qpInserted"
    />
    <vx-card ref="listCard" :title="$t('MRMR.Qp.Title')" title-color="black" refresh-content-action @refresh="refreshQpList"> 
      <vs-table
            ref="table"
            v-model="selected"
            pagination
            :max-items="itemsPerPage"
            search
            :data="qps"
          >
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="4">
              <feather-icon icon="PlusCircleIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="addNewData" v-b-tooltip.hover :title="$t('AddNew')" />
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" class="pb-4">
              <Pager
                :currentPage="currentPage"
                :itemsPerPage="itemsPerPage"
                :totalCount="qps.length"
                :queriedItems="queriedItems"
                :pageSizes="[10,20,50]"
                @pageChanged="onPageChanged"
              ></Pager>
            </vs-col>
          </vs-row>
        </div>
        <template slot="thead">
          <vs-th>{{$t('Action')}}</vs-th>
          <vs-th sort-key="name">{{$t('MRMR.Qp.Name')}}</vs-th>
          <vs-th sort-key="email">{{$t('MRMR.Qp.Email')}}</vs-th>
          <vs-th sort-key="occupation">{{$t('MRMR.Qp.Occupation')}}</vs-th>
          <vs-th sort-key="hireDate">{{$t('MRMR.Qp.HireDate')}}</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td width="100px" class="whitespace-no-wrap">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  @click.stop="editData(tr)"
                  v-b-tooltip.hover :title="$t('Edit')"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="openDeleteConfirm(tr.id, tr.name)"
                  v-b-tooltip.hover :title="$t('Delete')"
                />                           
              </vs-td>
              <vs-td>
                <p class="font-medium truncate">{{ tr.name }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium truncate">{{ tr.email }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium truncate">{{ getOccupationName(tr.occupation) }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium truncate">{{ tr.hireDate | toDate }}</p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>
<script>

import qpSideView from "./components/qpSideView.vue";
import moduleMRMR from "../../store/moduleMRMR.js";
import { Pager } from "../../../../shared/components";
import qpOccupationsEnum from "../../QPOccupationEnum";

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    Pager,
    qpSideView
  },
  data() {
    return {
      selected: [],    
      itemsPerPage: 20,
      isMounted: false,
      isSidebarActive: false,
      sidebarData: {}
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    qps() {
      return this.$store.state.mrmr.qps;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.qps.length;
    }
  },
  methods: {
    getOccupationName(id) {
      return qpOccupationsEnum.getNameFor(id);
    },
    refreshQpList() {
      this.$store.dispatch("mrmr/fetchQPListItems").then(() => {
        this.$refs.listCard.removeRefreshAnimation();
      });
    },
    onPageChanged(val) {
      this.itemsPerPage = val;
    },
    addNewData() {
      // Snomehow this doesn't work if I just pass an empty object
      this.sidebarData = {
        id: 0,
        name: "",
        email: "",
        occupation: null,
        hireDate: null,

        professionalOrderRegistrations: [],
        allowedProjets: []
      };
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.isSidebarActive = val;
    },
    openDeleteConfirm(id, name) {
      this.$deleteConfirmation({
        text: this.$t('MRMR.Qp.ConfirmDelete', { name }),
        accept:  () => this.deleteData(id)
      });
    },
    deleteData(id) {
      this.$store.dispatch("mrmr/removeQP", id)
        .then(() => {
          this.$notifyDeleteSuccess(this.$t("MRMR.Qp.QpDeleted"));
        });
    },
    editData(tr) {
      this.sidebarData = tr;
      this.toggleDataSidebar(true);
    },

    qpUpdated() {
      this.$notifySaveSuccess();
      this.toggleDataSidebar(false);

    },

    qpInserted() {
      this.$notifySuccess(this.$t('InsertSuccess'));
      this.toggleDataSidebar(false);
    }
  },
  created() {
    if (!moduleMRMR.isRegistered) {
      this.$store.registerModule("mrmr", moduleMRMR);
      moduleMRMR.isRegistered = true;
    }
  },
  mounted() {
    if (this.$store.state.mrmr.projects.length === 0) {

      this.$vs.loading();
      Promise.all([
        this.$store.dispatch("mrmr/fetchAllProjects"),
        this.$store.dispatch("mrmr/fetchProfessionalOrders")
      ]).then(() => {
        if (!this.isMounted) {
          this.$refs.listCard.refreshcard();
        }

        this.isMounted = true;

      }).finally(() => {
        this.$vs.loading.close();
      })
    } 
    else {
      if (!this.isMounted) {
        this.$refs.listCard.refreshcard();
      }
      this.isMounted = true;
    }
  }
};
</script>